"use client";

import { useEffect, useRef } from "react";
import { track } from "@/lib/stats-client";

// A Sweet Boost block (components/boost/Promoted.tsx): once a third of it is on screen, each promoted item in it
// counts a view for its boost, once a page (lib/stats.ts boost_view; clicks are counted by PageStats, data-boost).

const seen = new Set<string>();

export function BoostSeen({ ids, children }: { ids: string[]; children: React.ReactNode }) {
  const box = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const el = box.current;
    const fresh = ids.filter((id) => !seen.has(`${location.pathname} ${id}`));
    if (!el || !fresh.length) return;
    const observer = new IntersectionObserver(
      (entries) => {
        if (!entries.some((e) => e.isIntersecting)) return;
        for (const id of fresh) {
          seen.add(`${location.pathname} ${id}`);
          track("boost_view", id);
        }
        observer.disconnect();
      },
      { threshold: 0.3 },
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [ids]);
  return <div ref={box}>{children}</div>;
}
